import React, { FC, ReactNode } from 'react';
import PropTypes from 'prop-types';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAlloyFeatureFlag } from '@adsk/alloy-provider';
import Badge from '@adsk/alloy-react-badge';
import Tabs, { Tab } from '@adsk/alloy-react-tabs';
import theme from '@adsk/alloy-react-theme';
import { SCROLL_CONTAINER_ID } from '../../consts';

const MyHomeLabel: FC = () => (
  <>
    My Home
    <Badge
      color={theme.colors.yellowOrange300}
      style={{
        marginLeft: 8,
        color: theme.colors.charcoal900,
        ...theme.typography.labelSmall,
      }}
    >
      BETA
    </Badge>
  </>
);

type ProjectsHeaderTabs = {
  showUserHomeTab?: boolean;
};

type TabType = {
  tab: string;
  path: string;
  visible?: boolean;
  label: ReactNode;
};

const ProjectsHeaderTabs: FC<ProjectsHeaderTabs> = ({ showUserHomeTab }) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { value: showFiltersPanel } = useAlloyFeatureFlag('pl_filters_panel');

  const tabs = [
    {
      tab: 'home',
      label: <MyHomeLabel />,
      path: '/home',
      visible: showUserHomeTab,
    },
    {
      tab: 'projects',
      label: 'Projects',
      path: '/projects',
      visible: true,
    },
    {
      tab: 'projectTemplates',
      label: 'Project Templates',
      path: '/projects/templates',
      visible: true,
    },
  ] satisfies TabType[];

  const onTabChange = (tab: string) => {
    const nextTab = tabs.find((t) => t.tab === tab);

    const scrollContainer = document.getElementById(SCROLL_CONTAINER_ID);
    if (scrollContainer) scrollContainer.scrollTo(0, 0);

    if (nextTab?.path) {
      navigate(nextTab.path);
    }
  };

  const activeTab = tabs.find((tab) => pathname === tab.path)?.tab;

  return (
    <Tabs
      className="pendo-banner-target"
      style={{ margin: showFiltersPanel ? '32px 0 0 48px' : '32px 0' }}
      onChange={onTabChange}
      active={activeTab}
    >
      {tabs
        .filter((tab) => tab.visible)
        .map(({ label, tab }) => (
          <Tab key={tab} label={label} tab={tab} />
        ))}
    </Tabs>
  );
};

ProjectsHeaderTabs.propTypes = {
  showUserHomeTab: PropTypes.bool,
};

export default ProjectsHeaderTabs;
